import { H1 } from '@montel/montelpro-shared-components-v2';
import BundleForm from './BundleForm';
import { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { BUNDLES_GET_BUNDLE } from 'apiRoutes';
import { useBundleFormContext } from './BundleForm/BundleFormContext';

const EditBundlePage: FunctionComponent = () => {
	const { id } = useParams();
	const { setFormStateFromBundle } = useBundleFormContext();

	const { data: bundle } = useGetOnMount(
		`${BUNDLES_GET_BUNDLE}?BundleId=${id}`,
	);

	useEffect(() => {
		if (bundle) {
			setFormStateFromBundle(bundle);
		}
	}, [bundle]);

	return (
		<>
			<H1>Edit subscription bundle</H1>
			<BundleForm bundleId={Number(id)} />
		</>
	);
};

export default EditBundlePage;
